import React from "react";
import ReactDOM from "react-dom";

import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import rootReducer from "./reducers";
import { Route, Switch } from "react-router-dom";
import { Router } from "react-router";
import { createBrowserHistory } from "history";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import thunk from "redux-thunk";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";

import registerServiceWorker from "./registerServiceWorker";

import MainPageWithMenu from "./containers/MainPageWithMenu";
import Login from "./containers/Login";
import PrivateRoute from "./containers/PrivateRoute";
import ManageAppAdmin from "./containers/ManageApp";
import ManageAppUm from "./containers/ManageAppUm";
import MainPage from "./containers/MainPage";
import {
  ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_ANDROID,
  ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_IOS,
} from "./utils/config";
import Article from "./containers/MainPage/Article";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["login"],
};

const store = createStore(
  persistReducer(persistConfig, rootReducer),
  applyMiddleware(thunk)
);
const persistor = persistStore(store);

const history = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router history={history}>
        <Switch>
          <Route exact path="/tv" component={MainPage} />
          <Route path="/login" component={Login} />
          <Route
            path="/ios"
            render={() => (
              <Article
                customArticleId={ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_IOS}
              />
            )}
          />
          <Route
            path="/android"
            render={() => (
              <Article
                customArticleId={ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_ANDROID}
              />
            )}
          />
          <PrivateRoute
            path="/manageapp"
            componentAdmin={ManageAppAdmin}
            componentUm={ManageAppUm}
          />
          <Route path="/" component={MainPageWithMenu} />
        </Switch>
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js